import React, { useCallback, useEffect } from "react";
import {
  Box,
  CircularProgress,
  FormControlLabel,
  Grid,
  SelectChangeEvent,
  Stack,
  Typography,
} from "@mui/material";

import Dialog from "../../components/dialog/dialog";
import { useState } from "react";
import * as yup from "yup";
import Snackbar from "../../components/snackbar/snackbar";
// import { push, ref } from "firebase/database";
// import { firebaseDb } from "../../firebase/app";
import { getIsBuyAgent, getRole, getStaffUid, getUid } from "../../redux/authSlice";
import { useSelector } from "react-redux";
import MuiPhone from "../../components/input/mui-phone-input";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Checkbox from "@mui/material/Checkbox";
import { getDataOE } from "../../utils/firebase";
import { Button } from "../../components";
import ControlledInput from "../../components/input/controlled-input";
import Textarea from "../../components/textarea/textarea";
import CalendarOutlinedIcon from "../../assets/icon/calendar-outlined";
import CalendarFilledIcon from "../../assets/icon/calendar-filled";
import { formatDateFrom } from "../../utils/time-convert";
import IconButton from "../../components/icon-button/icon-button";
import RemoveIcon from "../../assets/icon/remove";
import { EMAIL_REGEX, MOBILE_REGEX } from "../../utils/utils.service";

import Scheduler from "../../components/utils/scheduler";
import { useResponsive } from "../../hooks/use-media-query";
import InputSearchIcon from "../../assets/icon/input-search";
import CloseIcon from "../../assets/icon/close";
import ScheduleIcon from "../../assets/icon/schedule";
import { post } from "../../api/setting/actions";
import { getDealerName } from "../../redux/userSlice";
import Selector from "../../components/select/select";
import useUsersQuery from "../../hooks/useUsersQuery";

const searchItems = ["year", "make", "model", "VIN", "mileage", "priceOnWebsite"];

// How the lead walked in — sent to the API as `leadSubSource`.
const SUB_SOURCE_OPTIONS = ["Walk-In", "Phone Up"];

const schema = yup.object().shape({
  firstName: yup
    .string()
    .required("Please enter your first name")
    .max(20, "first name must be at maximum 20 characters long"),
  lastName: yup.string().required("Please enter your last name"),
  phoneNumber: yup
    .string()
    .required("Please enter your phone number")
    .matches(MOBILE_REGEX, "please enter a valid phone number"),
  email: yup
    .string()
    .required("Please enter your email")
    .email("Please enter a valid email")
    .matches(EMAIL_REGEX, "Please enter a valid email"),
  manualLeadFirstMessage: yup.string().notRequired(),
  description: yup.string().required("Description is required").min(3).max(255),
  testDrive: yup.boolean(),
  make: yup.string().required(),
  mileage: yup.string().required(),
  model: yup.string().required(),
  priceOnWebsite: yup.string().required(),
  year: yup.string().required("please enter year"),
  VIN: yup
    .string()
    .required("VIN number is required")
    .matches(/^(?=[A-HJ-NPR-Z0-9]{17})[A-HJ-NPR-Z0-9]{17}$/, "Invalid VIN number format"), // Adjust the regex as needed
});

const steps = ["Lead Info", "Car Info", "AI Settings"];

interface FormInputs {
  firstName: string;
  lastName: string | any;
  phoneNumber: string;
  email: string | any;
  testDrive?: boolean;
  description: string;
  VIN: string;
  make: string;
  mileage: string;
  model: string;
  priceOnWebsite: string;
  year: string;
  manualLeadFirstMessage?: string | any;
}

const defaultValues: FormInputs = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "+1",
  description: "",
  VIN: "",
  testDrive: false,
  make: "",
  mileage: "",
  model: "",
  priceOnWebsite: "",
  year: "",
  manualLeadFirstMessage: "",
};

export default function CreateLead({ open, handleClose }: any) {
  // Selector
  const uid = useSelector(getUid);

  const [link, setLink] = useState("");
  const [searchLinkLoading, setSearchLinkLoading] = useState<boolean>(false);
  const [searchLinkError, setSearchLinkError] = useState<boolean>(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [calendarOpen, setCalendarOpen] = React.useState(false);
  const [scheduleOpen, setScheduleOpen] = React.useState(false);
  const [isSkipped, setIsSkipped] = React.useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = React.useState(false);
  const [lead, setLead] = useState(defaultValues);
  const [timestamp, setTimestamp] = useState<any>("");
  const [isFocused, setIsFocused] = useState(false);
  const [scheduleTimestamp, setScheduleTimestamp] = useState<any>("");
  const [message, setMessage] = React.useState({
    text: "",
    type: "",
    open: false,
  });
  const [selected, setSelected] = useState<any>();
  const [carsData, setCarsData] = useState<any[]>([]);
  const [filteredSearchOptions, setFilteredSearchOptions] = useState<any[]>([]);
  const [filters, setFilters] = useState({
    year: "",
    make: "",
    model: "",
    VIN: "",
    mileage: "",
    priceOnWebsite: "",
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [createLeadLoading, setCreateLeadLoading] = useState<boolean>(false);
  const isBuyAgent = useSelector(getIsBuyAgent);

  const role = useSelector(getRole);
  const staffUid = useSelector(getStaffUid);
  const dealerName = useSelector(getDealerName);

  const { data: users } = useUsersQuery();
  const [assignee, setAssignee] = useState<string>("");
  const [subSource, setSubSource] = useState<string>("");

  const { isMobile, isSmall } = useResponsive();

  const handleNext = () => {
    if (calendarOpen) {
      setCalendarOpen(false);
    } else {
      if (activeStep === 0) {
        const { email } = getValues();
        if (email) {
          trigger(["firstName", "lastName", "email"]);
        } else {
          setIsFocused(true);
          trigger(["firstName", "lastName", "phoneNumber"]);
        }
      }
      if (activeStep === 2) {
        trigger("description");
      }
      if (buttonDisabled) return;
      if (activeStep === steps.length - 1) {
        addNewLead();
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    }
  };

  const handleBack = () => {
    if (calendarOpen) {
      setCalendarOpen(false);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const handleOpenMenu = (modal: "appointment" | "schedule") => {
    if (modal === "appointment") {
      setCalendarOpen(true);
    } else {
      setScheduleOpen(true);
    }
    // setAnchorEl(event.currentTarget);
  };

  const {
    control,
    getValues,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    trigger,
    watch,
  } = useForm<FormInputs>({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const firstName = watch("firstName");
  const lastName = watch("lastName");
  const phoneNumber = watch("phoneNumber");
  const email = watch("email");
  const description = watch("description");
  const manualLeadFirstMessage = watch("manualLeadFirstMessage");

  function handleCloseDialog() {
    reset();
    setLink("");
    setIsFocused(false);
    setLead(defaultValues);
    setActiveStep(0);
    setCalendarOpen(false);
    setScheduleOpen(false);
    setFilters({ year: "", make: "", model: "", VIN: "", priceOnWebsite: "", mileage: "" });
    setSelected(undefined);
    setAssignee("");
    setSubSource("");
    setTimestamp("");
    setScheduleTimestamp("");
    handleClose();
  }

  const addNewLead = async () => {
    if (createLeadLoading) return;
    setCreateLeadLoading(true);
    const nowTimestamp = Date.now();

    const { firstName, lastName, email, phoneNumber, description, manualLeadFirstMessage }: any =
      getValues();

    // Staff create their own leads (assignee auto-set); managers pick an assignee.
    const assigneeName = users?.find((user) => user.uid === assignee)?.name || "";
    const repData =
      role === "staff"
        ? { repId: staffUid, repTo: dealerName }
        : assignee
        ? { repId: assignee, repTo: assigneeName }
        : {};

    const {
      mileage = null,
      year,
      priceOnWebsite,
      VIN,
      make = null,
      model = null,
    } = isBuyAgent
      ? getValues()
      : selected
      ? selected
      : { mileage: null, year: null, priceOnWebsite: null, VIN: null, make: null, model: null };

    const data: any =
      selected || isBuyAgent
        ? {
            firstName: firstName?.trim(),
            lastName: lastName?.trim(),
            email: email?.trim(),
            phoneNumber,
            description,
            VINNumber: isBuyAgent ? VIN : selected.vin,
            testDrive: lead.testDrive,
            make,
            mileage: mileage ? parseInt(mileage) : null,
            model,
            priceOnWebsite: priceOnWebsite ? parseInt(priceOnWebsite) : null,
            year: year ? parseInt(year) : null,
            source: "Manual Entry",
            manualLeadFirstMessage,
            scheduledTS: scheduleTimestamp,
            leadStatus: "hot",
            uid,
            ...repData,
          }
        : {
            firstName: firstName?.trim(),
            lastName: lastName?.trim(),
            email: email?.trim(),
            phoneNumber,
            description,
            testDrive: lead.testDrive,
            source: "Manual Entry",
            manualLeadFirstMessage,
            scheduledTS: scheduleTimestamp,
            uid,
            leadStatus: "hot",
            ...repData,
          };
    if (subSource) data.leadSubSource = subSource;
    if (!VIN) delete data.VIN;
    if (!make) delete data.make;
    if (!mileage) delete data.mileage;
    if (!model) delete data.model;
    if (!priceOnWebsite) delete data.priceOnWebsite;
    if (!phoneNumber || errors.phoneNumber || phoneNumber === "+1") delete data.phoneNumber;
    if (!year) delete data.year;
    if (!data.email) {
      delete data.email;
    }
    if (!data.phoneNumber) {
      delete data.phoneNumber;
    }

    if (timestamp !== "") {
      data.appointmentTime = timestamp;
      data.appointmentIsSet = true;
      data.appointmentSetTS = nowTimestamp;
    }
    if (scheduleTimestamp === "" || scheduleTimestamp === undefined) delete data.scheduledTS;

    if (manualLeadFirstMessage === "" || manualLeadFirstMessage === undefined) {
      delete data.manualLeadFirstMessage;
      delete data.scheduledTS;
    }

    if (isBuyAgent) {
      delete data.description;
      delete data.testDrive;
      if (!VIN) delete data.VINNumber;
    }

    try {
      // const newLeadRef = ref(firebaseDb, `dealers/${uid}/leads`);
      // await push(newLeadRef, data); // Push the data to Firebase
      await post(data, `salesagent-widget-init-api/manual-lead`);
      setCreateLeadLoading(false);
      handleCloseDialog();
      setMessage({
        text: "Lead added successfully!",
        type: "success",
        open: true,
      });
    } catch (error) {
      // Check if error is an instance of Error
      const errorMessage = error instanceof Error ? error.message : "An unknown error occurred";
      console.error("Error adding lead:", errorMessage);
      setCreateLeadLoading(false);
      setMessage({
        text: errorMessage,
        type: "error",
        open: true,
      });
    }
  };

  const handleSkipCarInfo = () => {
    setIsSkipped(true);
    setActiveStep(2);
  };

  const searchWithLink = async () => {
    setSearchLinkLoading(true);

    try {
      const response = await post({ url: link }, "/salesagent-car-data-finder");

      const { year, make, model, price, mileage, vin, email, first_name, last_name, phone_number } =
        response;
      setValue("make", make);
      setValue("year", year);
      setValue("model", model);
      setValue("priceOnWebsite", price.replace(/,/g, ""));
      setValue("VIN", vin);
      setValue("mileage", mileage);
      setValue("firstName", first_name);
      setValue("lastName", last_name);
      setValue("phoneNumber", phone_number);
      setValue("email", email);
      setSearchLinkLoading(false);
      setSearchLinkError(false);
    } catch {
      setSearchLinkError(true);
      setSearchLinkLoading(false);
      console.log("error");
    }
  };

  const handleGetCars = useCallback(() => {
    getDataOE(`/cars/${uid}`, "isCarSold", false).then((r: any) => {
      const entries = Object.entries(r);
      const items: any = entries.map(([key, item]: any, id) => {
        return { ...item, vin: key, id: id + 1 };
      });
      setCarsData(items);
      setFilteredSearchOptions(items);
      setIsLoading(false);
    });
  }, [uid]);

  // const handleGetDataByFilters = useCallback(() => {
  //   if (selected) return;
  //   const { year, make, model, VIN } = filters;
  //   if (!year && !make && !model && !VIN) {
  //     setFilteredSearchOptions([]);
  //     return;
  //   }
  //   setIsLoading(true);
  //   const filterItems = [
  //     { field: "uid", operator: "==", value: uid },
  //     { field: "make", operator: ">=", value: make },
  //     { field: "make", operator: "<=", value: make + "\uf8ff" },
  //     { field: "model", operator: ">=", value: model },
  //     { field: "model", operator: "<=", value: model + "\uf8ff" },
  //     { field: "isCarSold", operator: "==", value: false },
  //     { field: "year", operator: "==", value: Number(year) },
  //     { field: "vin", operator: ">=", value: VIN },
  //     { field: "vin", operator: "<=", value: VIN + "\uf8ff" },
  //   ].filter((filter) => filter.field !== "year" || (filter.field === "year" && filter.value));

  //   getDataByMultipleFilters(`carInventory`, filterItems, 0, 10).then((data: any) => {
  //     setFilteredSearchOptions(
  //       data.data.map((item: any) => ({ ...item, priceOnWebsite: item.price }))
  //     );
  //     setIsLoading(false);
  //   });
  // }, [filters, selected, uid]);

  // const { make = "", model, VIN = "", year = "" } = getValues();
  const handleGetFilterd = useCallback(() => {
    if (selected) return;
    const { make, model, VIN, year } = filters;

    const list = carsData;
    if (!list) {
      setFilteredSearchOptions([]);
      return;
    }
    const newList = list
      .filter((item: any) => {
        return (
          item.make?.toLowerCase()?.includes(make?.toLowerCase()) &&
          item.model?.toLowerCase()?.includes(model?.toLowerCase()) &&
          item.vin?.toLowerCase()?.includes(VIN?.toLowerCase()) &&
          item.year?.toString().includes(year)
        );
      })
      .map((item: any, id: number) => ({ ...item, id: id + 1, VIN: item.vin }));
    setFilteredSearchOptions(newList);
  }, [carsData, filters, selected]);

  useEffect(() => {
    handleGetFilterd();
  }, [handleGetFilterd, open]);

  useEffect(() => {
    if (open) {
      handleGetCars();
    }
  }, [handleGetCars, open]);

  useEffect(() => {
    if (selected) {
      const { VIN, year, make, model, priceOnWebsite, mileage } = selected;
      setFilters((filters) => ({ ...filters, VIN, year, make, mileage, priceOnWebsite, model }));
    }
  }, [selected, setValue]);

  // handle the disability of Next button
  useEffect(() => {
    if (activeStep === 0) {
      if (
        firstName &&
        lastName &&
        ((email && !errors.email) || (phoneNumber?.length === 12 && !errors.phoneNumber))
      ) {
        setButtonDisabled(false);
      } else {
        setButtonDisabled(true);
      }
    }
    if (activeStep === 1) {
      if (!selected) {
        setButtonDisabled(true);
      } else {
        setButtonDisabled(false);
      }
    }
    if (activeStep === 2) {
      if (calendarOpen) {
        setButtonDisabled(false);
      } else {
        if (!description) {
          setButtonDisabled(true);
        } else {
          setButtonDisabled(false);
        }
      }
    }
  }, [
    watch,
    activeStep,
    calendarOpen,
    firstName,
    lastName,
    email,
    phoneNumber,
    description,
    errors.email,
    errors.phoneNumber,
    errors.VIN,
    selected,
  ]);

  const renderTitle = "Create Lead";

  const renderTestDrive = (
    <Box marginBottom={"20px"}>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Stack>
          <Typography>Has the customer already test-driven this vehicle?</Typography>
        </Stack>
      </Box>

      <Box display={"flex"} justifyContent={"start"} gap={1}>
        <FormControlLabel
          sx={{ flexDirection: "row", margin: "0" }}
          value={true}
          control={
            <Checkbox sx={{ paddingLeft: "0" }} checked={lead.testDrive != false ? true : false} />
          }
          label="Yes"
          labelPlacement="bottom"
          checked={lead.testDrive}
          onClick={() => {
            setLead((prev) => ({
              ...prev,
              testDrive: true,
            }));
          }}
        />
        <FormControlLabel
          sx={{ flexDirection: "row" }}
          control={<Checkbox checked={lead.testDrive === false ? true : false} />}
          label="No"
          labelPlacement="bottom"
          onClick={() => {
            setLead((prev) => ({
              ...prev,
              testDrive: false,
            }));
          }}
        />
      </Box>
    </Box>
  );

  const renderContent = (
    <Box sx={{ width: "100%" }}>
      {!isBuyAgent && (
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          padding="5px 20px"
          sx={{
            backgroundColor: (theme: any) => theme.palette.secondary[100],
            alignItems: "center",
            height: "100px",
            borderRadius: "8px",
            paddingX: "50px",
            marginBottom: "20px",
            maxWidth: "100%",
            marginX: "15px",
          }}
        >
          {steps.map((label, index) => (
            <Box
              key={label}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {index !== 0 && (
                <Box
                  sx={{
                    height: "2px",
                    width: isMobile ? "0" : "180px",
                    backgroundColor: index <= activeStep ? "#07A4FC" : "#A0A0A0",
                    marginX: "5px",
                  }}
                ></Box>
              )}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "5px",
                  // marginBottom: "10px ",
                }}
              >
                <Box
                  width="20px"
                  height="20px"
                  borderRadius="50%"
                  textAlign="center"
                  color={index > activeStep ? "#07A4FC" : "white"}
                  sx={{
                    position: "relative",
                    backgroundColor:
                      index > activeStep ? "white" : index === activeStep ? "#07A4FC" : "#36B27E",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "11px",

                    border: index > activeStep ? "1px solid #07A4FC" : "none",
                  }}
                >
                  {index + 1}
                  <Box
                    sx={{
                      fontWeight: activeStep === index ? "bold" : "normal",
                      color: "black",
                      position: "absolute",
                      width: "100px",
                      top: "25px",
                    }}
                  >
                    <Typography
                      fontSize={isMobile ? "12px" : "14px"}
                      variant="body2"
                      fontWeight={index === activeStep ? 700 : 400}
                    >
                      {label}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      )}
      {isBuyAgent && (
        <Box
          sx={{
            paddingX: "16px",
            marginBottom: "12px",
            display: "flex",
            flexDirection: "row",
            gap: "12px",
          }}
        >
          <ControlledInput
            // label={"Link"}
            error={searchLinkError ? "an error happened, please try again later" : null}
            id="link"
            placeholder="Enter link"
            value={link}
            onChange={(e: any) => setLink(e.target.value)}
            // sx={{ width: "50%" }}
          />
          <Button
            onClick={() => {
              if (link && !searchLinkLoading) searchWithLink();
            }}
            variant="outlined"
            size="small"
            sx={{ height: "45px" }}
          >
            {searchLinkLoading ? <CircularProgress size={20} /> : "Find"}
          </Button>
        </Box>
      )}
      {isBuyAgent && (
        <Typography sx={{ paddingLeft: "16px", fontWeight: "700", fontSize: "20px" }}>
          Lead Info
        </Typography>
      )}
      {activeStep === 0 && (
        <Grid container p={1}>
          <Grid item xs={12} md={6} display={"flex"} flexDirection={"column"} gap={1} p={1}>
            <Controller
              control={control}
              name="firstName"
              render={({ field }) => (
                <ControlledInput
                  label={"First Name"}
                  error={errors.firstName?.message}
                  id="firstName"
                  placeholder="Enter your first name"
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6} display={"flex"} flexDirection={"column"} gap={1} p={1}>
            <Controller
              control={control}
              name="lastName"
              render={({ field }) => (
                <ControlledInput
                  label={"Last Name"}
                  error={errors.lastName?.message}
                  id="lastName"
                  placeholder="Enter your last name"
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6} display={"flex"} flexDirection={"column"} gap={1} p={1}>
            <Controller
              control={control}
              name="email"
              rules={{
                validate: (value) => {
                  const phone = getValues("phoneNumber");
                  if (!value && !phone) return "Email or phone is required";
                  return true;
                },
              }}
              render={({ field }) => (
                <ControlledInput
                  error={errors.email?.message}
                  id="email"
                  label="Email"
                  placeholder="Enter your email"
                  type="email"
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6} display={"flex"} flexDirection={"column"} gap={1} p={1}>
            <Controller
              control={control}
              name="phoneNumber"
              render={({ field }) => (
                <MuiPhone
                  label={"Phone Number"}
                  error={isFocused && errors.phoneNumber && errors.phoneNumber.message}
                  id="phoneNumber"
                  placeholder="Enter your phone number"
                  onFocus={() => setIsFocused(true)}
                  // onBlur={() => setIsFocused(false)}
                  {...field}
                />
              )}
            />
          </Grid>
        </Grid>
      )}
      {isBuyAgent && (
        <Typography
          sx={{
            marginX: "16px",
            marginTop: "16px",
            fontWeight: "700",
            fontSize: "20px",
            borderTop: "2px dashed #e6e6e6",
            paddingTop: "16px",
          }}
        >
          Car Info
        </Typography>
      )}
      {(activeStep === 1 || isBuyAgent) && (
        <Grid container p={1}>
          {searchItems.map((item) => (
            <Grid
              key={item}
              item
              xs={12}
              md={6}
              display={"flex"}
              flexDirection={"column"}
              gap={1}
              p={1}
            >
              {isBuyAgent ? (
                <Controller
                  control={control}
                  name={item as keyof FormInputs}
                  render={({ field }) => (
                    <ControlledInput
                      label={item
                        .replace(/([a-z])([A-Z])/g, "$1 $2")
                        .replace(/^./, (s) => s.toUpperCase())}
                      error={errors[item as keyof FormInputs]?.message}
                      id={item}
                      placeholder={
                        item === "VIN"
                          ? "Enter your VIN"
                          : `Enter your ${item
                              .replace(/([a-z])([A-Z])/g, "$1 $2")
                              .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
                              .toLowerCase()}`
                      }
                      {...field}
                    />
                  )}
                />
              ) : (
                <ControlledInput
                  disabled={item === "priceOnWebsite" || item === "mileage" || selected}
                  label={
                    <Typography sx={{ textTransform: "capitalize", fontSize: "14px" }}>
                      {item.replace(/([a-z])([A-Z])/g, "$1 $2")}
                    </Typography>
                  }
                  endAdornment={
                    item !== "priceOnWebsite" && item !== "mileage" && <InputSearchIcon />
                  }
                  type={item === "year" ? "number" : "text"}
                  onChange={(e: any) =>
                    setFilters((filters) => ({ ...filters, [item]: e.target.value }))
                  }
                  value={filters[item as keyof typeof filters]}
                  autoFocus={false}
                />
              )}
            </Grid>
          ))}
          {!isBuyAgent && (
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                height: "fit-content",
                maxHeight: isSmall ? "300px" : "170px",
                overflowY: "auto",
                marginTop: filteredSearchOptions.length > 0 ? "12px" : "0",
              }}
            >
              {isLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    padding: "50px",
                  }}
                >
                  <CircularProgress size={"30px"} color="inherit" />
                </Box>
              ) : (
                filteredSearchOptions.map((item, i) => (
                  <Box
                    sx={{
                      border: `1px solid ${selected?.VIN === item.vin ? "#07A4FC" : "#E5E5E5"}`,
                      borderRadius: "4px",
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "10px",
                      cursor: "pointer",
                      color: "#555555",
                      fontWeight: "400",
                      backgroundColor:
                        selected?.VIN === item.vin ? "#EAF7FE" : i % 2 === 0 ? "#F2F2F2" : "",
                      ":hover": {
                        backgroundColor: selected?.vin === item.vin ? "#EAF7FE" : "#F7F9FC",
                      },
                    }}
                    onClick={() => {
                      setIsSkipped(false);
                      setSelected(item);
                    }}
                    key={i}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: isSmall ? "column" : "row",
                        justifyContent: "space-between",
                        width: "90%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: isSmall ? "space-between" : "flex-start",
                          width: isSmall ? "100%" : "fit-content",
                          marginBottom: isSmall ? "20px" : "",
                        }}
                      >
                        <Box sx={{ width: isSmall ? "8%" : "80px" }}>{item.year}</Box>
                        <Box
                          sx={{
                            width: isSmall ? "30%" : "80px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            paddingRight: "10px",
                          }}
                        >
                          {item.make}
                        </Box>
                        <Box
                          sx={{
                            width: isSmall ? "30%" : "120px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            paddingRight: "10px",
                          }}
                        >
                          {item.model}
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          paddingRight: "10px",
                          width: isSmall ? "45%" : "200px",
                        }}
                      >
                        {item.vin}
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        width: "30px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      {selected && selected.vin === item.vin && (
                        <CloseIcon
                          onClick={(e: any) => {
                            e.stopPropagation();
                            setSelected(undefined);
                            setFilters((filters) => ({
                              ...filters,
                              year: "",
                              make: "",
                              model: "",
                              priceOnWebsite: "",
                              VIN: "",
                              mileage: "",
                            }));
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                ))
              )}
            </Grid>
          )}
        </Grid>
      )}
      {activeStep === 2 && !calendarOpen && !scheduleOpen && (
        <Box width={"100%"} p={1}>
          <Grid container spacing={2} sx={{ marginBottom: "20px" }}>
            {role !== "staff" && users && (
              <Grid item xs={12} md={6}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                  <Typography sx={{ fontSize: "14px", fontWeight: "400" }}>Assign to</Typography>
                  <Selector
                    fullWidth
                    sx={{
                      borderRadius: "8px",
                      backgroundColor: (theme: any) => theme.bg.paper,
                      borderWidth: "1px",
                    }}
                    withCustomMenuItems={true}
                    data={users.map((user) => ({
                      value: user.uid,
                      name: user.name,
                      labelComponent: () => (
                        <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                          {user.name}
                        </Typography>
                      ),
                    }))}
                    value={assignee}
                    onChange={(e: SelectChangeEvent) => setAssignee(e.target.value as string)}
                  />
                </Box>
              </Grid>
            )}
            <Grid item xs={12} md={role !== "staff" && users ? 6 : 12}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <Typography sx={{ fontSize: "14px", fontWeight: "400" }}>Lead type</Typography>
                <Selector
                  fullWidth
                  sx={{
                    borderRadius: "8px",
                    backgroundColor: (theme: any) => theme.bg.paper,
                    borderWidth: "1px",
                  }}
                  data={SUB_SOURCE_OPTIONS}
                  value={subSource}
                  onChange={(e: SelectChangeEvent) => setSubSource(e.target.value as string)}
                />
              </Box>
            </Grid>
          </Grid>

          {!isSkipped && renderTestDrive}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Controller
              control={control}
              name="description"
              render={({ field }) => (
                <Textarea
                  rows={4}
                  label="Tell AI about this lead"
                  error={errors.description?.message}
                  id="description"
                  placeholder="Enter your description"
                  type="text"
                  {...field}
                />
              )}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Controller
              control={control}
              name="manualLeadFirstMessage"
              render={({ field }) => (
                <Textarea
                  label="First message (optional)"
                  rows={4}
                  error={!!errors.manualLeadFirstMessage}
                  id="manualLeadFirstMessage"
                  placeholder="Enter first message"
                  type="text"
                  {...field}
                />
              )}
            />
          </Box>
          {!manualLeadFirstMessage ? null : scheduleTimestamp !== "" ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
                Select time to schedule first message:
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "80px",
                  justifyContent: "space-between",
                  borderRadius: "15px",
                  border: "1px solid #07A4FC",
                  backgroundColor: "#CEEBF840",
                  padding: "10px",
                }}
              >
                <Box display="flex" flexDirection="row" gap="10px" alignItems="center">
                  <CalendarFilledIcon />
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      Message Scheduled
                    </Typography>
                    <Typography variant="caption">{formatDateFrom(scheduleTimestamp)}</Typography>
                  </Box>
                </Box>
                <Box display="flex" flexDirection="row" gap="5px" alignItems="center">
                  <Button
                    // sx={{ width: "150px" }}
                    variant="outlined"
                    startIcon={<ScheduleIcon />}
                    color="primary"
                    onClick={() => handleOpenMenu("schedule")}
                  >
                    Change Time
                  </Button>
                  <IconButton
                    icon={<RemoveIcon />}
                    onClick={() => {
                      setScheduleTimestamp("");
                    }}
                  />
                </Box>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "5px",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
                Select date and time to schedule first message:
              </Typography>
              <Button
                sx={{ width: "170px" }}
                variant="outlined"
                startIcon={<ScheduleIcon />}
                color="primary"
                onClick={() => handleOpenMenu("schedule")}
              >
                Schedule
              </Button>
            </Box>
          )}
          {timestamp !== "" ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
                Select date and time for appointment book:
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "80px",
                  justifyContent: "space-between",
                  borderRadius: "15px",
                  border: "1px solid #07A4FC",
                  backgroundColor: "#CEEBF840",
                  padding: "10px",
                }}
              >
                <Box display="flex" flexDirection="row" gap="10px" alignItems="center">
                  <CalendarFilledIcon />
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      Appointment Booked
                    </Typography>
                    <Typography variant="caption">{formatDateFrom(timestamp)}</Typography>
                  </Box>
                </Box>
                <Box display="flex" flexDirection="row" gap="5px" alignItems="center">
                  <Button
                    sx={{ width: "150px" }}
                    variant="outlined"
                    startIcon={<CalendarOutlinedIcon />}
                    color="primary"
                    onClick={() => handleOpenMenu("appointment")}
                  >
                    Change Date
                  </Button>
                  <IconButton
                    icon={<RemoveIcon />}
                    onClick={() => {
                      setTimestamp("");
                    }}
                  />
                </Box>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "5px",
                marginTop: "20px",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
                Please set appointment here
              </Typography>
              <Button
                sx={{ width: "170px" }}
                variant="outlined"
                startIcon={<CalendarOutlinedIcon />}
                color="primary"
                onClick={() => handleOpenMenu("appointment")}
              >
                Open Calendar
              </Button>
            </Box>
          )}
        </Box>
      )}
      {activeStep === 2 && calendarOpen && (
        <Box
          sx={{ display: "flex", flexDirection: "row", justifyContent: "center", width: "100%" }}
        >
          <Scheduler
            onSave={(timestamp: string) => setTimestamp(timestamp)}
            onClose={() => setCalendarOpen(false)}
            timestamp={timestamp}
            type="appointment"
          />
        </Box>
      )}
      {activeStep === 2 && scheduleOpen && (
        <Scheduler
          onSave={(timestamp: string) => setScheduleTimestamp(timestamp)}
          onClose={() => setScheduleOpen(false)}
          timestamp={scheduleTimestamp}
          type="schedule"
        />
      )}
    </Box>
  );

  const renderActions = !calendarOpen && !scheduleOpen && (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          width: "100%",
          gap: "10px",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={activeStep === 1 ? 4 : 6}>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              disabled={activeStep === 0}
              onClick={handleBack}
            >
              Back
            </Button>
          </Grid>
          {activeStep === 1 && (
            <Grid item xs={activeStep === 1 ? 4 : 6}>
              <Button fullWidth variant="outlined" color="primary" onClick={handleSkipCarInfo}>
                Skip
              </Button>
            </Grid>
          )}
          <Grid item xs={activeStep === 1 ? 4 : 6}>
            <Button
              sx={{ height: "36.5px" }}
              fullWidth
              onClick={
                isBuyAgent
                  ? async () => {
                      const { email } = getValues();
                      const triggerList: (keyof FormInputs)[] = email
                        ? [
                            "firstName",
                            "lastName",
                            "year",
                            "make",
                            "model",
                            "priceOnWebsite",
                            "email",
                          ]
                        : [
                            "firstName",
                            "lastName",
                            "phoneNumber",
                            "year",
                            "make",
                            "model",
                            "priceOnWebsite",
                          ];
                      if (!email) setIsFocused(true);
                      const result = await trigger(triggerList);
                      console.log("Is valid?", result);
                      if (result) addNewLead();
                    }
                  : handleNext
              }
              variant="contained"
            >
              {isBuyAgent ? (
                "Submit"
              ) : activeStep === steps.length - 1 ? (
                calendarOpen ? (
                  "save"
                ) : createLeadLoading ? (
                  <CircularProgress size={20} />
                ) : (
                  "Create"
                )
              ) : (
                "Next"
              )}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );

  return (
    <>
      <Snackbar
        handleClose={() => setMessage({ text: "", open: false, type: "" })}
        message={message.text}
        open={message.open}
        type={message.type}
      />
      <Dialog
        maxWidth={"sm"}
        onSubmit={handleSubmit(addNewLead)}
        open={open}
        handleClose={handleCloseDialog}
        info={
          activeStep === 1 ? (
            <>
              <Typography variant="body1" fontWeight={"700"} color={"white"}>
                Skip Button:
              </Typography>
              <br />
              <Typography color={"white"} variant="body2" padding={"10px"}>
                Dealers can now create a lead without assigning a VIN number. For example, if a
                customer visits the dealership and hasn&apos;t decided on a specific car yet, the
                dealer can create the lead and skip entering car details. Once the customer decides,
                the details can be updated later.
              </Typography>
            </>
          ) : activeStep === 2 ? (
            <>
              <Typography variant="body1" fontWeight={"700"} color={"white"}>
                Schedule Appointment Button:
              </Typography>
              <br />
              <Typography color={"white"} variant="body2" padding={"10px"}>
                Dealers can set an appointment while creating a lead. For example, if a customer has
                already chosen a specific car or wants to schedule a visit immediately, the dealer
                can add the appointment directly during the lead creation process.
              </Typography>
            </>
          ) : null
        }
        renderTitle={renderTitle}
        renderContent={renderContent}
        renderActions={renderActions}
      />
    </>
  );
}
